import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { CalibrationReport } from '../components/reports/CalibrationReport';
import { PerformanceTrendReport } from '../components/reports/PerformanceTrendReport';
import { QACoverageReport } from '../components/reports/QACoverageReport';
import { CategoryDeficiencyReport } from '../components/reports/CategoryDeficiencyReport';
import { AuditLogReport } from '../components/reports/AuditLogReport';
import { DigestDeliveryStatusPanel } from '../components/reports/DigestDeliveryStatus';
import { authService } from '../services/authService';

const DIGEST_TAB_INDEX = 4;
const AUDIT_TAB_INDEX = 5;

export const ReportsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isTenantAdmin, setIsTenantAdmin] = useState(false);

  // The audit trail is TenantAdmin-only — it records supervisor activity, so a Supervisor must
  // not be able to pull their peers' access history. The API enforces this independently; this
  // only keeps a tab the user cannot use from appearing.
  useEffect(() => {
    authService.getUserAsync().then((user) => {
      setIsTenantAdmin(user?.role === 'TenantAdmin');
    });
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>Reports</Typography>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
      >
        <Tab label="AI Calibration" />
        <Tab label="Performance Trending" />
        <Tab label="QA Coverage" />
        <Tab label="Category Deficiency" />
        <Tab label="Digest Delivery" value={DIGEST_TAB_INDEX} />
        {isTenantAdmin && <Tab label="Audit Trail" value={AUDIT_TAB_INDEX} />}
      </Tabs>

      {activeTab === 0 && <CalibrationReport />}
      {activeTab === 1 && <PerformanceTrendReport />}
      {activeTab === 2 && <QACoverageReport />}
      {activeTab === 3 && <CategoryDeficiencyReport />}
      {activeTab === DIGEST_TAB_INDEX && <DigestDeliveryStatusPanel />}
      {activeTab === AUDIT_TAB_INDEX && isTenantAdmin && <AuditLogReport />}
    </Box>
  );
};
